<div class="grid-container">
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
      <legend class="usa-legend usa-legend--large">Negative Shipment Reporting</legend>
    </div>
  </div>
  <form id="negativeShipmentSubmissionGroup" role="form" [formGroup]="negativeShipmentSubmissionGroup">

  <div class="grid-row" *ngIf="reportSubmissionSuccess">
    <div class="usa-alert usa-alert--success maxw-full">
      <div class="usa-alert__body">
          <p class="usa-alert__text">
          GSA has received your Negative Shipment Report(s) for the below selected Reporting Year(s)/Quarter(s), selected Move Type(s) and Transportation Type(s).
        </p>
      </div>
    </div>
  </div>

  <div class="grid-row" *ngIf="reportSubmissionFailure">
    <div class="usa-alert usa-alert--error usa-alert--no-icon">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          Record already exists. Negative Shipment report submission can't be proceeded.
        </p>
      </div>
    </div>
  </div>

  <div class="grid-row grid-gap padding-y-4">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3" *ngIf="showCarrierTSPs">
      <label for="carrierTSPSelect" class="usa-label">TSPs</label>
      <select id="carrierTSPSelect" class="usa-select maxw-full" formControlName='carrierTSPSelect' (change)="loadCarrierApprovalInfo($event.target.value)">
        <option hidden value='' selected disabled>Choose...</option>
        <option *ngFor="let carrierTspSingle of carrierTSPsList" [value]="carrierTspSingle.value">
          {{carrierTspSingle.name}}</option>
      </select>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label for="reportingYrQuarterSelect" class="usa-label">Reporting Year/Quarter</label>
      <select id="reportingYrQuarterSelect" class="maxw-full usa-select" formControlName='reportingYrQuarterSelect'>
        <option hidden value='' selected disabled>Choose...</option>
        <option *ngFor="let reportingYrQuarterSingle of reportingYrQuarterList"
          [value]="reportingYrQuarterSingle.value">{{reportingYrQuarterSingle.name}}</option>
      </select>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label for="moveTypeSelect" class="usa-label">Move Type</label>
      <select (change)="changeMoveType($event)" id="moveTypeSelect" class="maxw-full usa-select" formControlName='moveTypeSelect'>
        <option hidden value='' selected disabled>Choose...</option>
        <option *ngFor="let transTypeSingle of movingTypeList" [value]="transTypeSingle.value">
          {{transTypeSingle.name}}</option>
      </select>
    </div>

    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
      <label for="transTypeSelect" class="usa-label">Transportation Type</label>
      <select id="transTypeSelect" class="usa-select maxw-full" formControlName='transTypeSelect'>
        <option hidden value='' selected disabled>Choose...</option>
        <option *ngFor="let transTypeSingle of transTypeList" [value]="transTypeSingle.value">
          {{transTypeSingle.name}}</option>
      </select>
    </div>
  </div>
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <button type="button" class="usa-button" [disabled]="!negativeShipmentSubmissionGroup.valid"
      (click)='submitReport(this.negativeShipmentSubmissionGroup.value)'>Submit</button>
    </div>
  </div>

  </form>
</div>